import { matchSorter } from "match-sorter";

var getItems = function getItems(_ref) {
  var filter = _ref.filter,
      options = _ref.options;
  return filter ? matchSorter(options, filter, {
    keys: ["value"]
  }) : options;
};

export { getItems };